import { FC, useEffect, useRef, useState } from 'react';
import IconInfo from '../../assets/icon_info.png';
import { IOption } from '../../entities';
import styles from './VerticalSelector.module.scss';

interface VerticalSelectorProps {
  selectedValue?: string;
  options: IOption[];
  onClick: (value: string) => void;
  infoOnClick?: (value: string) => void;
  isInfoVisible?: (value: string) => boolean;
}

const VerticalSelector: FC<VerticalSelectorProps> = ({
  selectedValue,
  options,
  onClick,
  infoOnClick,
  isInfoVisible,
}) => {
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const verticalSelectorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const verticalSelector = verticalSelectorRef.current;

    const checkScrollPosition = () => {
      if (verticalSelector) {
        const { scrollTop, scrollHeight, clientHeight } = verticalSelector;
        const tolerance = 1;

        setIsAtTop(scrollTop <= tolerance);
        setIsAtBottom(scrollHeight - (scrollTop + clientHeight) <= tolerance);
      }
    };

    verticalSelector?.addEventListener('scroll', checkScrollPosition);

    // Initial check in case the component loads in a scrolled position
    checkScrollPosition();

    return () => verticalSelector?.removeEventListener('scroll', checkScrollPosition);
  }, [options]);

  return (
    <div className={styles.container}>
      {options.length > 6 && !isAtTop && <div className={`${styles.overflowIndicator} ${styles.top}`}></div>}
      <div ref={verticalSelectorRef} className={styles.optionsContainer}>
        {options.map((option, index) => (
          <button
            key={`${option.value}-${index}`}
            className={`${styles.button} ${option.value === selectedValue ? `${styles.active}` : ''}`}
            onClick={() => onClick(option.value)}
          >
            {option.name}

            {infoOnClick && (!isInfoVisible || isInfoVisible(option.value)) && (
              <img
                src={IconInfo}
                width={25}
                height={25}
                alt="info"
                onClick={(e) => {
                  e.stopPropagation();
                  infoOnClick(option.value);
                }}
              />
            )}
          </button>
        ))}
      </div>
      {options.length > 6 && !isAtBottom && <div className={`${styles.overflowIndicator} ${styles.bottom}`}></div>}
    </div>
  );
};

export default VerticalSelector;
